import React, {useEffect} from 'react';
import {
    IonContent,
    IonIcon,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonModal
} from '@ionic/react';
import FilterSidebar from '../components/FilterSidebar';
import JobCard from '../components/JobCard';
import JobDetails from "../components/JobDetails";
import {FacebookLoader} from "./Loader/FacebookLoader";
import NoDataFoundOrSelectedDiv from "./NoDataFoundOrSelectedDiv";
import useStore from "../zustand/useStore";
import {actionToGetJobPostingByFilter} from "../apiHelpers/CommonAction";
import {arrowBack} from "ionicons/icons";
import { Virtuoso } from 'react-virtuoso';
import JobProfileCard from "./JobProfileCard";
import JobUserProfileDetailComponent from "./JobUserProfileDetailComponent";

export default function JobPortalCandidateRoleComponentDesktop({isOpen,onDidDismiss,myJobPostsData,jobDetailsData,selectedJobListUserType = 1, setJobDetailsData}) {
    const {jobPostingState,selectedWorkTypes,setDeservingCandidatesProfileData,selectedDepartments,selectedState,experience,salaryRange} = useStore();
    const {loading,jobPostings} = jobPostingState;
    const isFetchingRef = React.useRef(false);

    const callFunctionToFilterJobPosting = async (isLoad = true)=>{
        if (isFetchingRef.current) return;
        isFetchingRef.current = true;
        const payload = {};
        if (selectedWorkTypes.length > 0) payload.work_type = selectedWorkTypes;
        if (selectedDepartments.length > 0) payload.selectedDepartments = selectedDepartments;
        if (selectedState.length > 0) payload.selectedState = selectedState;
        if (experience > 0) payload.experience = experience;
        if (salaryRange > 0) payload.salary = salaryRange;
        payload.me_mode = !!myJobPostsData;
        payload.user_type = selectedJobListUserType;
        await actionToGetJobPostingByFilter(isLoad,payload);
        isFetchingRef.current = false;
    }

    useEffect(() => {
        if(jobPostings?.length){
            setJobDetailsData(jobPostings[0]);
        }else{
            setJobDetailsData(null);
        }
    },[jobPostings])

    useEffect(() => {
        if(isOpen) {
            callFunctionToFilterJobPosting();
        }
    },[isOpen])

    const openJobCandidateProfileDetail = (jobData)=>{
        setJobDetailsData(jobData);
    }

    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onDidDismiss}
            className={"modal_in_detail_desktop_full_view"}
        >
            <IonHeader className="job_detail_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton className={"close_job_post_button"} onClick={onDidDismiss}>
                            <IonIcon icon={arrowBack}/>
                        </IonButton>
                    </IonButtons>
                    <div className="job_detail_sheet_header_text">
                        <div className="job-basic-info-image">
                            <span className="job-basic-info-text">
                                {myJobPostsData ? 'My' : ''} Job Posts List
                            </span>
                        </div>
                    </div>
                </IonToolbar>
            </IonHeader>
            <IonContent className="job-portal-desktop page-content">
                <div className="job-portal-container three-panel-grid">
                    {/* Filter Sidebar */}
                    <aside className="filter-sidebar">
                        <FilterSidebar selectedJobListUserType={selectedJobListUserType} myJobPostsData={myJobPostsData}/>
                    </aside>

                    {/* Job List */}
                    <section className="job-list-section">
                        {(loading) ?
                            <div className={'job-list'}>
                                <div className={'job-card'}>
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                                <div className={'job-card'}>
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                                <div className={'job-card'}>
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                            </div>
                            :
                            (jobPostings && jobPostings?.length > 0) ?
                                <Virtuoso
                                    className={'job-list'}
                                    data={jobPostings}
                                    style={{height: 'calc(100vh - 115px)'}}
                                    endReached={() => callFunctionToFilterJobPosting(false)}
                                    overscan={5}
                                    itemContent={(index, job) => (
                                        (selectedJobListUserType === 2) ?
                                            <JobProfileCard
                                                key={job.id}
                                                jobProfileData={job}
                                                openJobCandidateProfileDetail={openJobCandidateProfileDetail}
                                            />
                                        :
                                            <JobCard
                                                job={job}
                                                key={job.id}
                                                selectedId={jobDetailsData?.id}
                                                handleJobItemClick={setJobDetailsData}
                                            />
                                    )}
                                />
                                :
                                <div className="job-list">
                                    <NoDataFoundOrSelectedDiv/>
                                </div>
                        }
                    </section>

                    {/* Job Details */}
                    <aside className="job-details-sidebar">
                        {(jobDetailsData?.id) ?
                            (selectedJobListUserType === 2) ?
                                <JobUserProfileDetailComponent deservingCandidatesProfileData={jobDetailsData}/>
                                :
                                <JobDetails jobDetailsData={jobDetailsData}/>
                            :
                            <NoDataFoundOrSelectedDiv isDetailPanel={true}/>
                        }
                    </aside>
                </div>
            </IonContent>
        </IonModal>
    )
}
